/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import ITipoIdentificacion from 'Infotrack@Modelos/administracion/tipoIdentificacion/entidades/tipoIdentificacion';
import React from 'react';
import TipoIdentificacionCM from '../controladorModelo/tipoIdentificacionCM';
import { acciones, IEstadoTipoIdentificacion } from '../reductorTipoIdentificacion';
import TipoIdentificacionVista from '../vista/tablaTipoIdentificacionVista';

const tipoIdentificacionCM = new TipoIdentificacionCM();

const TableTipoIdentificacionCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [tipoIdentificacions, setTipoIdentificacions] = React.useState<ITipoIdentificacion[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoTipoIdentificacion>();

    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarTipoIdentificacion();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarTipoIdentificacion = () => {
        manejadorIndicadorCargaGlobal(true);
        tipoIdentificacionCM.consultarTipoIdentificacion().then((tipoIdentificacions) => {
            setTipoIdentificacions(tipoIdentificacions);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadTipoIdentificacion?: ITipoIdentificacion) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadTipoIdentificacion, tipoFormulario } });
    };

    const confirmarEliminacion = (tipoIdentificacion: ITipoIdentificacion) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarTipoIdentificacion(tipoIdentificacion),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };
    const eliminarTipoIdentificacion = (tipoIdentificacion: ITipoIdentificacion) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        tipoIdentificacionCM.eliminarTipoIdentificacion(tipoIdentificacion).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <TipoIdentificacionVista
            tipoIdentificacions={tipoIdentificacions}
            cargarTipoIdentificacion={cargarTipoIdentificacion}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableTipoIdentificacionCV;
